import { render, staticRenderFns } from "./SendVerificationEmail.vue?vue&type=template&id=667dc60a&scoped=true&"
import script from "./SendVerificationEmail.vue?vue&type=script&lang=js&"
export * from "./SendVerificationEmail.vue?vue&type=script&lang=js&"
import style0 from "./SendVerificationEmail.vue?vue&type=style&index=0&id=667dc60a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667dc60a",
  null
  
)

export default component.exports